import "./MenuSectionHead.css";
export default function MenuSectionHead(props) {
	return (
		<div className="MenuSectionHead">
			<span className="MenuSectionHeadHeading">{props.Heading}</span>
			<span className="MenuSectionHeadDescription">{props.Description}</span>
		</div>
	);
}
